import { z } from "zod";

import { imageFormatSchema } from "api/schemas/imageCollectionApiSchema";
import { topicSchema } from "api/schemas/topicsApiSchema";
import { nullToUndefined } from "api/utils";

const dimensionSchemaBase = z.object({
  co_curator: nullToUndefined(z.string()),
  description: z.string(),
  description_original: nullToUndefined(z.string()),
  id: z.string(),
  image_url: z.string().nullable(),
  images: nullToUndefined(imageFormatSchema),
  is_custom_dimension: z.boolean(),
  is_machine_translated: nullToUndefined(z.boolean()),
  name: z.string(),
  parent_topic: nullToUndefined(
    z.object({
      co_curator: z.string().optional(),
      id: z.string(),
      image_url: nullToUndefined(z.string()),
      name: z.string(),
    }),
  ),
  parent_topic_id: z.string(),
  status: z.enum(["Active", "Draft", "Idea", "Inactive"]),
  subtitle: z.string().optional(),
  subtitle_original: nullToUndefined(z.string()),
  topic_ids: z.array(z.string()),
});

const dimensionCreateSchema = dimensionSchemaBase;

export const dimensionSchema = dimensionSchemaBase.extend({
  topics: nullToUndefined(z.array(topicSchema)),
});

export const newCustomDimensionSchema = dimensionSchema.pick({
  description: true,
  id: true,
  image_url: true,
  is_custom_dimension: true,
  name: true,
  parent_topic_id: true,
  status: true,
  subtitle: true,
  topics: true,
});

export const dimensionPostSchema = z.object({
  dimension: dimensionCreateSchema,
});

export const dimensionIdPutSchema = z.object({
  dimension: dimensionSchema,
});

export const getDimensionByIdResponseSchema = z.object({
  dimension: dimensionSchema,
  topics: z.array(topicSchema),
});

export const getDimensionsResponseSchema = z.object({
  dimensions: z.array(dimensionSchema),
});
